<template>
  <div style="background-color: #edf4fc;padding-bottom: 0.1rem;">
    <div style="overflow: hidden;">
      <div class="celebrity-content">
        <el-row :gutter="20" class="row-size">
          <el-col class="celebrity-content-1" :span="12">
            <div>
              <div class="celebrity-content-3">根据学校名称搜索老师简介：</div>
              <div class="content-input">
                <el-input
                  v-model="schoolName"
                  placeholder="请输入学校名称"
                  class="content-input-el"
                  clearable
                  @keyup.enter.native="schoolFind()"
                >
                </el-input>
                <el-button
                  type="primary"
                  style="height: 0.34rem;margin-left: 0.2rem"
                  @click="schoolFind()"
                >
                  搜索
                </el-button>
              </div>
            </div>
          </el-col>
          <el-col class="celebrity-content-2" :span="12">
            <div>
              <div class="celebrity-content-3">根据老师姓名搜索老师简介：</div>
              <div class="content-input">
                <el-input
                  v-model="teacherName"
                  placeholder="请输入老师姓名"
                  class="content-input-el"
                  clearable
                  @keyup.enter.native="dataFind()"
                >
                </el-input>
                <el-button
                  type="primary"
                  style="height: 0.34rem; margin-left: 0.2rem"
                  @click="dataFind()"
                >
                  搜索
                </el-button>
              </div>
            </div>
          </el-col>
          <el-col :span="24" style="padding: 0;">
            <div class="celebrity-content-4">
              <div class="content-body-box" v-for="item in fileData" :key="item.id">
                <div class="box-img">
                  <img :alt="item.teacher" class="img-center" :src="item.picture">
                </div>
                <div class="box-info-1">
                  <span>姓名：{{ item.teacher }}</span>
                </div>
                <div class="box-info-1">
                  <span>学校：{{ item.school }}</span>
                  &nbsp;&nbsp;&nbsp;
                  <span>地址：{{ item.address }}</span>
                </div>
                <div class="box-info-1">
                  <span>专业：{{ item.major }}</span>
                  &nbsp;&nbsp;&nbsp;
                  <span>人气：{{ item.popular }}</span>
                  &nbsp;&nbsp;&nbsp;
                  <a href="javascript:void(0);" @click="likeTeacher(item)">为老师点赞</a>
                </div>
                <div class="box-info-2">
                  <span>简介：</span>
                  <p style="font-size: 0.13rem;text-indent: 0.26rem;word-break: break-all;" v-html="item.introduction"></p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="24" class="pagination">
            <div>
              <el-pagination
                :current-page="currentPage"
                :page-size="pageSize"
                background
                layout="prev, pager, next"
                :total="total"
                @current-change="handleCurrentChange"
              />
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="independence">
        <div class="independence-div">
          <a href="javascript:void(0);" @click="contentFind()">点击回到全部老师资料</a>
        </div>
        <div class="independence-div">
          <div class="news">MBA联盟</div>
          <div v-for="item in teacherData1" :key="item.id" class="divcolor">
            <a href="javascript:void(0);" class="cell-link" @click="teacherFind(item.teacher)">
              {{ item.teacher }} （{{ item.introduction }}）
            </a>
          </div>
        </div>
        <div class="independence-div">
          <div class="news">M超联盟</div>
          <div v-for="item in teacherData2" :key="item.id" class="divcolor">
            <a href="javascript:void(0);" class="cell-link" @click="teacherFind(item.teacher)">
              {{ item.teacher }} （{{ item.introduction }}）
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 按需导入 API 接口
import { selectCelebrity, getCelebritySchool, getCelebrityTeacher, likeTeacherAPI } from '@/api/celebrityAPI'

export default {
  name: 'Celebrity',
  data() {
    return {
      teacherName: '',
      schoolName: '',
      currentPage: 1,
      pageSize: 4,
      total: 1,
      fileData: [],
      teacherData1: [],
      teacherData2: [],
      teacherPopulars: [],
      teacherPopular: {
        teacherId: '',
        teacherNum: 0
      },
      teacherYesNo: 0,
      idButton: 0,
      loading: true
    }
  },
  created() {
    this.contentFind()
    this.findTeacher1()
    this.findTeacher2()
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {
    async findTeacher1() {
      const { data: res } = await getCelebritySchool('MBA联盟', 1, 20)
      this.teacherData1 = res.data[2]
    },
    async findTeacher2() {
      const { data: res } = await getCelebritySchool('M超联盟', 1, 20)
      this.teacherData2 = res.data[2]
    },
    async likeTeacher(item) {
      for (let i = 0; i < this.teacherPopulars.length; i = i + 1) {
        if (this.teacherPopulars[i].teacherId === item.id && this.teacherPopulars[i].teacherNum === 1) {
          this.teacherYesNo = 1
        }
      }
      if (this.teacherYesNo === 0) {
        const { data: res } = await likeTeacherAPI(item.id)
        if (res.code === 200) {
          this.$message({
            message: '已为' + item.teacher + '老师点赞',
            type: 'success'
          })
          this.teacherPopular.teacherId = item.id
          this.teacherPopular.teacherNum = 1
          this.teacherPopulars.push(this.teacherPopular)
          this.teacherPopular = {}
          this.teacherYesNo = 0
          if (this.idButton === 1) {
            const { data: res } = await getCelebrityTeacher(this.teacherName, this.currentPage, this.pageSize)
            this.fileData = res.data[2]
            this.total = res.data[0]
            for (let i = 0; i < this.fileData.length; i = i + 1) {
              this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
              this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
              this.fileData[i].introduction = this.fileData[i].introduction.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
            }
          }
          if (this.idButton === 2) {
            const { data: res } = await getCelebritySchool(this.schoolName, this.currentPage, this.pageSize)
            this.fileData = res.data[2]
            this.total = res.data[0]
            for (let i = 0; i < this.fileData.length; i = i + 1) {
              this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
              this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
              this.fileData[i].introduction = this.fileData[i].introduction.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
            }
          }
          if (this.idButton === 3) {
            const { data: res } = await selectCelebrity(this.currentPage, this.pageSize)
            this.fileData = res.data[2]
            this.total = res.data[0]
            for (let i = 0; i < this.fileData.length; i = i + 1) {
              this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
              this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
              this.fileData[i].introduction = this.fileData[i].introduction.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
            }
          }
        } else {
          this.$message({
            message: '点赞失败',
            type: 'warning'
          })
        }
      } else {
        this.$message({
          message: '只能为老师点赞一次',
          type: 'warning'
        })
      }
      this.teacherYesNo = 0
    },
    async contentFind() {
      const { data: res } = await selectCelebrity(this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 3
      for (let i = 0; i < this.fileData.length; i = i + 1) {
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
      }
    },
    async schoolFind() {
      this.currentPage = 1
      const { data: res } = await getCelebritySchool(this.schoolName, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 2
      for (let i = 0; i < this.fileData.length; i = i + 1) {
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
      }
    },
    async dataFind() {
      this.currentPage = 1
      const { data: res } = await getCelebrityTeacher(this.teacherName, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 1
      for (let i = 0; i < this.fileData.length; i = i + 1) {
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
      }
    },
    async teacherFind(teacher) {
      this.currentPage = 1
      const { data: res } = await getCelebrityTeacher(teacher, this.currentPage, this.pageSize)
      this.fileData = res.data[2]
      this.total = res.data[0]
      this.idButton = 1
      for (let i = 0; i < this.fileData.length; i = i + 1) {
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        this.fileData[i].introduction = this.fileData[i].introduction.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
      }
      document.documentElement.scrollTop = 200
    },
    async handleCurrentChange(val) {
      this.currentPage = val
      document.documentElement.scrollTop = 380
      if (this.idButton === 1) {
        const { data: res } = await getCelebrityTeacher(this.teacherName, this.currentPage, this.pageSize)
        this.fileData = res.data[2]
        this.total = res.data[0]
        for (let i = 0; i < this.fileData.length; i = i + 1) {
          this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.fileData[i].introduction = this.fileData[i].introduction.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        }
      }
      if (this.idButton === 2) {
        const { data: res } = await getCelebritySchool(this.schoolName, this.currentPage, this.pageSize)
        this.fileData = res.data[2]
        this.total = res.data[0]
        for (let i = 0; i < this.fileData.length; i = i + 1) {
          this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.fileData[i].introduction = this.fileData[i].introduction.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        }
      }
      if (this.idButton === 3) {
        const { data: res } = await selectCelebrity(this.currentPage, this.pageSize)
        this.fileData = res.data[2]
        this.total = res.data[0]
        for (let i = 0; i < this.fileData.length; i = i + 1) {
          this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.fileData[i].introduction = this.fileData[i].introduction.replace(/\r/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
          this.fileData[i].introduction = this.fileData[i].introduction.replace(/\n/g, '<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a:hover {
  color: red;
}
a p div span {
  font-size: 0.13rem;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.celebrity-content {
  width: 70%;
  float: left;
}
.celebrity-content-1 {
  padding-right: 0;
  border-left: 1px dashed rgb(223, 221, 221);
  border-top: 1px dashed rgb(223, 221, 221);
}
.celebrity-content-2 {
  border-left: 1px dashed rgb(223, 221, 221);
  border-top: 1px dashed rgb(223, 221, 221);
  border-right: 1px dashed rgb(223, 221, 221);
  padding-left: 0;
}
.celebrity-content-3 {
  font-size: 0.13rem;
  margin: 0.1rem 0.1rem 0.05rem;
  color: #4f2f4f
}
.celebrity-content-4 {
  overflow: hidden;
  border-left: 1px dashed rgb(223, 221, 221);
  border-right: 1px dashed rgb(223, 221, 221);
  border-top: 1px dashed rgb(223, 221, 221);
}
.row-size {
  margin: 0.1rem!important;
}
.content-input {
  margin: 0.1rem;
  .content-input-el {
    width: 2rem;
  }
}
.content-body-box {
  width: 96%;
  margin: 0.1rem;
  height: 2.3rem;
  background-color: rgb(247, 247, 247);
  border-radius: 0.1rem;
  border: 1px solid rgb(216, 215, 215);
}
.box-img {
  float: left;
  height: 2.1rem;
  margin: 0.1rem;
}
.img-center {
  height: 2.1rem;
  display: block;
  margin: 0 auto;
}
.box-info-1 {
  margin-top: 0.05rem;
  padding-left: 0.24rem;
  font-size: 0.13rem;
}
.box-info-2 {
  overflow:auto;
  height: 1.4rem;
  margin-top: 0.05rem;
  margin-right: 0.1rem;
  padding-right: 0.1rem;
  padding-left: 0;
  font-size: 0.13rem;
  background-color: #fff;
  p {
    text-indent: 0.24rem;
    margin-block-start: 0.05rem;
    margin-block-end: 0.05rem;
    text-align: justify;
    line-height: 1.6;
  }
}
.pagination {
  padding: 0.1rem;
  border-bottom: 1px dashed rgb(223, 221, 221);
  border-left: 1px dashed rgb(223, 221, 221);
  border-right: 1px dashed rgb(223, 221, 221);
}
.independence {
  float: right;
  width: 30%;
}
.independence-div {
  border: 1px dashed rgb(223, 221, 221);
  margin-top: 0.1rem;
  margin-right: 0.1rem;
  padding: 0.1rem;
  font-size: 0.13rem;
}
.independence-div a:hover {
  color: red;
}
.independence-div div a:hover {
  color: blue;
}
.news {
  margin: 0.1rem 0.1rem 0.1rem 0.05rem;
  font-size: 0.17rem;
  font-weight: 700;
  text-align: center;
}
.cell-link {
  display: inline-block;
  font-size: 0.13rem;
  width: 2.4rem;
  padding: 0.06rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.divcolor:hover {
  background-color: rgb(163, 252, 163);
}
.el-button {
  width: 0.6rem;
  vertical-align: middle;
  text-align: center;
  padding: 0;
  font-size: 0.15rem;
  background-color: #061238;
  font-weight: 500;
}
.el-button > span {
  text-align: center;
}
.el-pagination {
  text-align: center;
}
/deep/ .el-radio__input {
  display: none;
}
/deep/ .el-radio {
  margin-right: 0.07rem;
  margin-bottom: 0.05rem;
}
/deep/ .el-radio__label {
  padding-left: 0;
  font-size: 0.13rem;
}
/deep/ .el-tabs__nav-scroll {
  border-bottom: none;
}
/deep/ .el-tabs__item {
  height: 0.24rem;
  line-height: 0.24rem;
  font-size: 0.13rem;
}
/deep/ .el-tabs__header {
  margin: 0 0 0.02rem;
}
/deep/ .el-form-item__label {
  padding: 0;
}
/deep/ .el-input__inner {
  font-size: 0.13rem;
}
</style>
